export const ROUTES = {
  HOME: '/actions',
  FLOOR_PLANS: '/floorplans',
  FEATURED_VIDEOS: '/featuredvideos',
  PROPERTY: {
    MANAGE: '/property/manage',
    ADD: '/property/add',
    EDIT: '/property/edit',
  },
  LINE: {
    ADD: '/line/add',
    EDIT: '/line/edit',
  },
  UNITS: {
    MANAGE: '/units/manage',
    ADD: '/units/add',
    EDIT: '/units/edit',
  },
  DESIGNS: {
    MANAGE: '/designs/manage',
  },
  DESIGN_LAYOUTS: {
    EDIT: '/design_layouts/edit',
    ADD: '/design_layouts/add',
  },
  ROOM_DESIGNS: {
    EDIT: '/room_designs/edit',
    ADD: '/room_designs/add',
  },
  LEVEL: {
    ADD: '/level/add',
    EDIT: '/level/edit',
  },
  PACKAGES: {
    MANAGE: '/packages/manage',
    CREATE: '/packages/create',
    EDIT: '/packages/edit',
  },
  MODELS_3D: {
    MANAGE: '/models/manage',
    CREATE: '/models/create',
    EDIT: '/models/edit',
  },
  LIVING: {
    DASHBOARD: '/living/dashboard',
    VARIANTS: {
      MANAGE: '/living/variants/manage',
      CREATE: '/living/variants/create',
      EDIT: '/living/variants/edit',
    },
    LINKS: {
      CREATE: '/living/links/create',
      EDIT: '/living/links/edit',
    },
  },
  REAL_ESTATE_COMPANIES: '/real-estate-companies',
  MANAGE_LINE_IMAGES: '/manage-line-images',
  IMAGES: '/images',
  SIGNIN: '/signin',
}
